module.exports = __webpack_public_path__ + "img/receipt17.3741c990.png";